// extracted by mini-css-extract-plugin
export default {"btn":"LoginForm_btn__J7PmW","input":"LoginForm_input__JGHHH","errorMessage":"LoginForm_errorMessage__fxlJD"};